import React, { useEffect, useState } from "react";
import "./payment-details-content.component.sass";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css'
import { icons } from "src/statics/icons";
import { PaymentSectionInfoComponent } from "../payment-section-info/payment-section-info.component";
import { PaymentService } from "../../services/payment/payment.service";
import { PaymentDetails } from "../../types/payment-details";
import { Grid, TextField, FormControl, InputLabel, Select, MenuItem, Button, CircularProgress } from "@material-ui/core";
import { Card } from "src/types/card";
import { config } from "src/statics/toastr";

export default function PaymentDetailsContentComponent() {
  const paymentService = new PaymentService();
  const [t] = useTranslation();
  const { createBuildingsIco } = icons;
  const [loading, setLoading]: any = useState(true);
  const [saving, setSaving]: any = useState(false);
  const [country, setCountry] = useState("");
  const [card, setCard] = useState(new Card());
  const [paymentDetails, setPaymentDetails] = useState(new PaymentDetails());
  const [billingDetails, setBillingDetails]: any = useState(new PaymentDetails());
  const saveBillingDetails = async(): Promise<void> => {
    try {
      setSaving(true);
      await paymentService.savePaymentDetails(billingDetails);
      toast.success(t("save_payment_details_success"), config);
    } catch (error) {
      toast.error(t("save_payment_details_error"), config);
    } finally {
      setSaving(false);
    }
  };

  async function fetchData() {
    setLoading(true);
    const paymentDetails = await paymentService.listPaymentDetails();
    const card = paymentDetails.card;
    setCard((card && card.type) ? card : new Card());
    delete paymentDetails.card;
    setPaymentDetails(paymentDetails);
    setBillingDetails(paymentDetails);
    setCountry(paymentDetails.country);
    setLoading(false);
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  const inputChangeHandler = (event: any, prop: string) => {
    const value = event?.target?.value;
    const obj: any = {};
    obj[prop] = value;
    setBillingDetails({...billingDetails, ...obj})
    if (prop === "country") {
      setCountry(value);
    }
  };

  return (
    <div className="payment-details">
      <div className="section-title">
        <PaymentSectionInfoComponent
          title="billing-details"
          subTitle="address-and-method"
        />
      </div>
      {loading &&  (
          <div className="loader-area">
            <CircularProgress />
          </div>
        )}
      <div className="payment-details-content">
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6} className="left-container">
            <div className="card-title">{t("bill-address")}</div>
            {!loading && (<div className="card-body">
              <div className="bill-details">
                <TextField name="name" type="text" className="bill-input" label={t("company_name")} 
                    onChange={(event: any) => inputChangeHandler(event, 'name')}  value={billingDetails.name} InputLabelProps={{ shrink: billingDetails.name ? true : false }}/>
                <Grid container direction="row" justify="space-between">
                  <Grid item xs={3} sm={3}> 
                    <FormControl style={{width: "calc(100% - 10px)"}} className="bill-input country-filter">
                      <InputLabel id="country">{t("country")}</InputLabel>
                      <Select
                        labelId="country"
                        id="country-select"
                        value={country}
                        onChange={(event: any) => inputChangeHandler(event, 'country')}
                      >
                        <MenuItem value={'AT'}>AT</MenuItem>
                        <MenuItem value={'EG'}>EG</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4} sm={4}> 
                    <TextField name="postalCode" type="number" className="bill-input" style={{width: "calc(100% - 30px)"}} label={t("postalCode")} 
                    onChange={(event: any) => inputChangeHandler(event, 'postalCode')} value={billingDetails.postalCode} InputLabelProps={{ shrink: billingDetails.postalCode ? true : false }}/>
                  </Grid>
                  <Grid item xs={5} sm={5}> 
                    <TextField name="state" type="text" className="bill-input" style={{width: "calc(100% - 18px)"}} label={t("city")} 
                    onChange={(event: any) => inputChangeHandler(event, 'state')} value={billingDetails.state} InputLabelProps={{ shrink: billingDetails.state ? true : false }}/>
                  </Grid>
                </Grid>
                <TextField name="address" type="text" className="bill-input" label={t("address")} 
                onChange={(event: any) => inputChangeHandler(event, 'address')} value={billingDetails.address} InputLabelProps={{ shrink: billingDetails.address ? true : false }}/>
                <Grid container direction="row" justify="space-between">
                  <Grid item xs={6} sm={6}> 
                  <TextField name="taxId" type="text" className="bill-input" style={{width: "calc(100% - 30px)"}} label={t("vat_number")} 
                    onChange={(event: any) => inputChangeHandler(event, 'taxId')} InputProps={{readOnly: paymentDetails.taxId ? true : false}} value={billingDetails.taxId} InputLabelProps={{ shrink: billingDetails.taxId ? true : false }}/>
                  </Grid>
                  <Grid item xs={6} sm={6}> 
                    <TextField name="companyId" type="text" className="bill-input" style={{width: "calc(100% - 20px)"}} label={t("company_register_number")} 
                    onChange={(event: any) => inputChangeHandler(event, 'companyId')} value={billingDetails.companyId} InputLabelProps={{ shrink: billingDetails.companyId ? true : false }}/>
                  </Grid>
                </Grid>
              </div>
            </div> )}
          </Grid>
          <Grid item xs={12} lg={6} className="right-container">
            <div className="card-title">{t("payment-method")}</div>
            {!loading && (<div className="card-body">
              <div className="bill-details">
                <Grid container direction="row" justify="space-between" spacing={1}>
                  <Grid item xs={3} sm={2}> 
                    <div className="card-type">
                      <img src={"/icons/cards/" + card.type.toLowerCase() + ".svg"} alt="" className=""/>
                    </div>
                  </Grid>
                  <Grid item xs={9} sm={10}> 
                    <TextField name="cardType" type="text" InputProps={{readOnly: true}} InputLabelProps={{ shrink: card.type ? true : false }} value={card.type.toUpperCase()} className="bill-input card-type-input" label={t("card_type")} style={{width: "calc(100% - 12px)"}}/>
                  </Grid>
                </Grid>
              </div>
            </div> )}
          </Grid>
        </Grid> 
        {!loading && (<div className="section-footer">
          <div className="info">
            <img src="/icons/info.svg" alt="info" />
            <div className="footer-text">* {t("vat-text")}</div>
          </div>
          <Button
            variant="contained"
            disabled={saving}
            className="btn-tool btn-warning"
            onClick={saveBillingDetails}
          >
            {!saving && <div className="btn-flex"><img
              alt="icon"
              className="icon icon-refresh"
              src={createBuildingsIco}
            />{t("save")}</div>}
            {saving && <CircularProgress color="primary" />}
          </Button>
        </div> )}
      </div>
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        pauseOnHover
      />
    </div>
  );
}
